import { Link } from "react-router-dom";
import { useSettings } from "@/hooks/useSettings";

// Build the running ticker feed by cycling through the editor-supplied items,
// prefixing each cycle with the label so the marquee always shows the section
// heading at regular intervals as items scroll past.
function buildTicker(label, items) {
  const list = Array.isArray(items) ? items.filter((i) => i && i.text) : [];
  if (list.length === 0) return [];
  const labelItem = { text: label || "Editor's Choice", url: "/editorials", isLabel: true };
  const built = [];
  const CYCLES = 3;
  const PER_CYCLE = 7;
  for (let c = 0; c < CYCLES; c++) {
    built.push(labelItem);
    for (let j = 0; j < PER_CYCLE; j++) {
      built.push(list[(c * PER_CYCLE + j) % list.length]);
    }
  }
  return built;
}

const isExternal = (u) => typeof u === "string" && /^(https?:)?\/\//i.test(u);

export default function Ticker() {
  const { settings } = useSettings();
  const list = buildTicker(settings.ticker_label, settings.ticker_items);
  if (list.length === 0) return null;
  return (
    <div className="max-w-[1440px] mx-auto">
      <div className="border-b border-black bg-black text-white overflow-hidden" data-testid="site-ticker">
        <div className="flex whitespace-nowrap ticker-track py-2 mono text-xs uppercase tracking-[0.225em]">
          {list.map((item, i) => {
            const cls = `px-[18px] flex items-center transition-colors shrink-0 ${item.isLabel ? "text-amber-500 font-semibold" : "hover:text-amber-500"}`;
            const testid = item.isLabel ? `ticker-label-${i}` : `ticker-link-${i}`;
            const content = (
              <>
                <span className={`mr-4 ${item.isLabel ? "text-white" : "text-amber-500"}`}>◆</span>
                {item.text}
              </>
            );
            return isExternal(item.url) ? (
              <a
                key={i}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={testid}
                title={item.alt || undefined}
                className={cls}
              >
                {content}
              </a>
            ) : (
              <Link
                key={i}
                to={item.url || "/"}
                data-testid={testid}
                title={item.alt || undefined}
                className={cls}
              >
                {content}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
